import * as React from "react";
import { withRouter, BrowserHistory } from "react-router-dom";
import "./static/PageNotFound.scss";
import { isNullOrUndefined } from "util";
class PageNotFound extends React.Component<{
    homeOnClick: Function,    
    history: BrowserHistory
}> {
    render() {
        return (
            <div className="root PageNotFoundRoot">
            <header>
                <div className="title-container">
                    <h4>Error 404</h4>
                    <h1>Page not found</h1>
                </div>
            </header>
            <section>
                <div className="content-wrapper">
                    <p><span>Oops!</span></p>
                    <p>We don't have the page you are looking for. Are you sure you are in the right place?</p>
                    <div className="site-links">
                        <a href="#" className="back" onClick={this.props.history.goBack}>Go back</a>
                        <p>or</p>
                        <a 
                            href="#" 
                            className='return-home' 
                            onClick={
                            () => {
                                if (!isNullOrUndefined(this.props.homeOnClick)) {
                                    this.props.homeOnClick();
                                } else {
                                    this.props.history.push("/");
                                }
                            }
                        } 
                        >
                        Return to homepage
                        </a>
                    </div>
                </div>
            </section>
            </div>
        );
    }
}
export default withRouter(PageNotFound);


// WEBPACK FOOTER //
// ./src/view/PageNotFound/PageNotFound.tsx